module.exports = __webpack_public_path__ + "img/4.40fd0895.jpg";